
export const sequences2034 = [
  ['ear', 'bear', 'barge', 'beggar'],
  ['ate', 'east', 'skate', 'streak'],
  ['ear', 'gear', 'graze', 'grazed'],
  ['ate', 'fate', 'after', 'father'],
  ['ear', 'read', 'bread', 'barbed'],
  ['ear', 'care', 'trace', 'create'],
  ['ear', 'real', 'clear', 'cellar'],
  ['ate', 'rate', 'water', 'waiter'],
  ['ash', 'cash', 'crash', 'search'],
  ['one', 'tone', 'stone', 'stoned'],
  ['lie', 'mile', 'smile', 'simple'],
  ['rat', 'tear', 'after', 'faster'],
  ['ear', 'real', 'relay', 'barely'],
  ['tea', 'date', 'cadet', 'coated'],
  ['act', 'cast', 'coast', 'castor'],
  ['rid', 'ride', 'wired', 'wilder'],
  ['ram', 'army', 'marry', 'martyr'],
  ['ate', 'tale', 'least', 'castle'],
  ['tea', 'seat', 'skate', 'staked'],
  ['are', 'rage', 'range', 'garden'],
  ['doc', 'cold', 'could', 'cloudy'],
  ['mob', 'boom', 'broom', 'boomer'],
  ['rat', 'star', 'stray', 'pastry'],
  ['set', 'east', 'yeast', 'steady'],
  ['eat', 'tear', 'cater', 'carpet'],
  ['bet', 'belt', 'table', 'tablet'],  // Replaced 'albert' with 'tablet' from sequences2025
  ['lap', 'pale', 'plane', 'alpine'],
  ['ask', 'sake', 'skate', 'casket'],
  ['are', 'tear', 'great', 'gather'],
  ['car', 'race', 'clear', 'cellar'],
  ['sea', 'ease', 'erase', 'easier'],
  ['lap', 'pale', 'place', 'palace'],
  ['one', 'nose', 'snore', 'reason'],
  ['are', 'rate', 'extra', 'baxter'],
  ['led', 'deal', 'laden', 'handle'],
  ['sue', 'sure', 'super', 'supper'],
  ['red', 'dear', 'adore', 'ordeal'],
  ['ear', 'near', 'crane', 'dancer'],
  ['ace', 'cave', 'carve', 'cavern'],
  ['bar', 'bear', 'brace', 'breach'],
  ['sat', 'seat', 'feast', 'safety'],
  ['old', 'load', 'aloud', 'upload'],
  ['ear', 'earl', 'early', 'really'],
  ['her', 'hero', 'chore', 'hector'],
  ['tea', 'tear', 'trade', 'hatred'],
  ['ran', 'darn', 'drank', 'ranked'],
  ['let', 'felt', 'filet', 'lifted'],
  ['hut', 'hunt', 'haunt', 'naught'],
  ['are', 'dear', 'bread', 'badger'],
  ['tea', 'beat', 'bathe', 'breath'],
  ['red', 'dare', 'beard', 'barged'],
  ['ear', 'read', 'raced', 'sacred'],
  ['ice', 'eric', 'nicer', 'cretin'],
  ['son', 'nose', 'stone', 'honest'],
  ['tea', 'heat', 'theta', 'threat'],
  ['ole', 'cole', 'close', 'closer'],
  ['sea', 'sale', 'least', 'stable'],
  ['ear', 'dare', 'beard', 'barged'],
  ['sat', 'last', 'tesla', 'lasted'],
  ['try', 'troy', 'forty', 'frosty'],
  ['ran', 'near', 'range', 'danger'],
  ['use', 'sure', 'serum', 'summer'],
  ['art', 'tear', 'earth', 'rather'],
  ['say', 'stay', 'nasty', 'sanity'],
  ['rip', 'pair', 'rapid', 'diaper'],
  ['eat', 'tear', 'grate', 'garnet'],
  ['are', 'care', 'trace', 'create'],
  ['sat', 'salt', 'steal', 'stable'],
  ['ten', 'neat', 'taken', 'tanker'],  // Replaced 'kent' with 'neat' from sequences2025
  ['set', 'east', 'tesla', 'stella'],
  ['nor', 'horn', 'honor', 'honour'],
  ['lie', 'evil', 'liver', 'relive'],
  ['ear', 'year', 'yearn', 'nearby'],
  ['car', 'care', 'cater', 'cartel'],
  ['are', 'care', 'carve', 'carved'],
  ['doc', 'code', 'decoy', 'comedy'],
  ['see', 'seen', 'scene', 'screen'],
  ['ear', 'dear', 'cedar', 'sacred'],
  ['lab', 'bail', 'basil', 'alibis'],
  ['are', 'bare', 'break', 'banker'],
  ['ate', 'tale', 'tesla', 'stella'],
  ['rat', 'tear', 'trade', 'trader'],
  ['lad', 'lead', 'delta', 'talked'],
  ['art', 'rate', 'alert', 'travel'],  // Replaced 'albert' with 'travel' from sequences2030
  ['are', 'read', 'grade', 'agreed'],
  ['sat', 'last', 'splat', 'postal'],
  ['hit', 'thin', 'thing', 'hating'],
  ['nap', 'pain', 'plain', 'alpine'],
  ['set', 'east', 'beast', 'breast'],
  ['eat', 'seat', 'beast', 'basket'],
  ['cap', 'camp', 'cramp', 'camper'],
  ['sat', 'star', 'trash', 'thrash'],
  ['lab', 'able', 'blame', 'gamble'],
  ['set', 'seat', 'skate', 'staked'],
  ['eat', 'team', 'steam', 'master'],
  ['rid', 'ride', 'aired', 'raised'],
  ['ear', 'care', 'raced', 'traced'],
  ['tea', 'east', 'tease', 'senate'],
  ['pin', 'spin', 'spine', 'sniper'],
  ['eat', 'seat', 'least', 'latest'],
  ['hut', 'thou', 'tough', 'though'],
  ['sea', 'east', 'asset', 'assert'],
  ['are', 'bare', 'brave', 'verbal'],
  ['tea', 'rate', 'react', 'cartel'],
  ['not', 'torn', 'intro', 'orient'],
  ['age', 'gate', 'stage', 'staged'],
  ['the', 'heat', 'teach', 'chaste'],
  ['are', 'gear', 'great', 'garret'],
  ['eat', 'seat', 'stake', 'streak'],
  ['bar', 'bare', 'baker', 'banker'],
  ['con', 'coin', 'tonic', 'action'],
  ['sue', 'used', 'fused', 'defuse'],
  ['are', 'earl', 'large', 'gravel'],
  ['eat', 'seat', 'caste', 'stance'],
  ['ale', 'meal', 'maple', 'palmer'],
  ['ear', 'read', 'padre', 'parade'],
  ['red', 'deer', 'breed', 'bender'],
  ['are', 'rage', 'anger', 'danger'],
  ['tie', 'diet', 'tried', 'direct'],
  ['ate', 'tear', 'alert', 'travel'],
  ['ear', 'dear', 'aired', 'raised'],
  ['sea', 'base', 'beast', 'breast'],
  ['car', 'care', 'crave', 'carver'],
  ['rid', 'dirt', 'tired', 'credit'],
  ['set', 'site', 'exist', 'sexist'],
  ['ear', 'real', 'realm', 'palmer'],
  ['sat', 'east', 'waste', 'sweaty'],
  ['sit', 'spit', 'strip', 'spirit'],
  ['eat', 'east', 'asset', 'assert'],
  ['car', 'care', 'carve', 'carved'],
  ['ear', 'earl', 'flare', 'raffle'],
  ['rob', 'bore', 'bored', 'border'],
  ['cop', 'chop', 'pooch', 'poncho'],
  ['ten', 'note', 'stone', 'stolen'],
  ['ate', 'date', 'taped', 'update'],
  ['are', 'race', 'scare', 'scared'],
  ['sec', 'case', 'cease', 'ceased'],
  ['tea', 'tale', 'latte', 'talent'],
  ['yep', 'prey', 'reply', 'player'],
  ['cat', 'coat', 'costa', 'castor'],
  ['are', 'real', 'layer', 'lawyer'],
  ['han', 'hang', 'chang', 'change'],
  ['mac', 'calm', 'claim', 'climax'],
  ['set', 'east', 'asset', 'assert'],
  ['eat', 'tale', 'plate', 'planet'],
  ['art', 'tear', 'terra', 'artery'],
  ['tea', 'tale', 'later', 'learnt'],
  ['ole', 'hole', 'hotel', 'hostel'],
  ['pet', 'step', 'paste', 'aspect'],
  ['eat', 'rate', 'later', 'travel'],
  ['elm', 'meal', 'email', 'mailed'],
  ['not', 'tone', 'tenor', 'throne'],
  ['are', 'gear', 'large', 'larger'],
  ['due', 'rude', 'under', 'turned'],
  ['ear', 'rear', 'terra', 'artery'],
  ['her', 'hero', 'other', 'mother'],
  ['dog', 'dong', 'doing', 'coding'],
  ['aid', 'idea', 'aired', 'raised'],
  ['sin', 'sing', 'swing', 'sawing'],
  ['car', 'care', 'scare', 'scared'],
  ['nor', 'worn', 'owner', 'wonder'],
  ['cat', 'chat', 'catch', 'catchy'],
  ['lie', 'mile', 'email', 'amelia'],
  ['the', 'heat', 'theta', 'threat'],
  ['let', 'tale', 'alert', 'travel'],
  ['led', 'lied', 'piled', 'dimple'],
  ['men', 'mine', 'miner', 'remain'],
  ['art', 'rate', 'great', 'target'],
  ['aid', 'raid', 'aired', 'admire'],
  ['red', 'deer', 'creed', 'reduce'],
  ['ate', 'east', 'state', 'latest'],
  ['sea', 'east', 'slate', 'stable'],
  ['ear', 'race', 'cedar', 'dancer'],
  ['rat', 'cart', 'react', 'traced'],
  ['lad', 'deal', 'delta', 'detail'],
  ['her', 'here', 'cheer', 'cheery'],
  ['sea', 'ease', 'lease', 'sealed'],
  ['fat', 'fate', 'feast', 'safety'],
  ['tea', 'team', 'meant', 'mental'],
  ['ole', 'love', 'lover', 'revolt'],
  ['pet', 'type', 'typed', 'deputy'],
  ['art', 'tear', 'cater', 'carpet'],
  ['eat', 'rate', 'react', 'cartel'],
  ['per', 'rope', 'prove', 'proved'],
  ['any', 'many', 'mayan', 'cayman'],
  ['pet', 'step', 'steep', 'pester'],
  ['set', 'step', 'steep', 'pester'],
  ['ben', 'bone', 'noble', 'belong'],
  ['old', 'loud', 'mould', 'module'],
  ['her', 'here', 'there', 'either'],
  ['one', 'once', 'ocean', 'beacon'],
  ['she', 'shoe', 'shore', 'ashore'],
  ['set', 'west', 'sweet', 'newest'],
  ['sat', 'last', 'least', 'castle'],
  ['art', 'trap', 'party', 'pastry'],
  ['any', 'many', 'manly', 'mainly'],
  ['end', 'tend', 'noted', 'stoned'],
  ['ale', 'lame', 'metal', 'amulet'],
  ['tap', 'part', 'party', 'partly'],
  ['art', 'rate', 'later', 'travel'],
  ['aim', 'maid', 'admit', 'dammit'],
  ['one', 'once', 'coven', 'convey'],
  ['pat', 'tape', 'plate', 'planet'],
  ['lie', 'lied', 'field', 'lifted'],
  ['set', 'step', 'upset', 'purest'],
  ['lad', 'deal', 'pedal', 'paddle'],
  ['bat', 'brat', 'abort', 'bogart'],
  ['ate', 'tear', 'heart', 'breath'],
  ['pot', 'stop', 'spout', 'sprout'],
  ['rub', 'bury', 'rugby', 'grubby'],
  ['red', 'dear', 'drake', 'parked'],
  ['tea', 'seat', 'taste', 'statue'],
  ['tie', 'tied', 'tried', 'credit'],
  ['use', 'used', 'fused', 'defuse'],
  ['say', 'stay', 'hasty', 'trashy'],
  ['per', 'prey', 'perry', 'prayer'],
  ['act', 'cart', 'track', 'racket'],
  ['end', 'dean', 'named', 'demand'],
  ['tea', 'east', 'sweat', 'wasted'],
  ['eat', 'east', 'tesla', 'salute'],
  ['nor', 'iron', 'groin', 'boring'],
  ['son', 'nose', 'senor', 'person'],
  ['the', 'heat', 'bathe', 'breath'],
  ['ran', 'darn', 'drain', 'rained'],
  ['eat', 'seat', 'tesla', 'stable'],
  ['ray', 'pray', 'party', 'partly'],
  ['say', 'easy', 'yeast', 'safety'],
  ['end', 'need', 'dense', 'sensed'],
  ['sea', 'seal', 'stale', 'staple'],
  ['sat', 'star', 'roast', 'pastor'],
  ['rat', 'rate', 'trade', 'hatred'],
  ['tea', 'rate', 'alter', 'learnt'],
  ['and', 'land', 'gland', 'dangle'],
  ['cat', 'cart', 'trace', 'create'],
  ['lip', 'pile', 'piled', 'dimple'],
  ['pen', 'open', 'phone', 'phoned'],
  ['nor', 'worn', 'drown', 'onward'],
  ['use', 'sure', 'surge', 'grouse'],
  ['sin', 'sign', 'swing', 'sewing'],
  ['lie', 'lied', 'piled', 'dimple'],
  ['met', 'team', 'matey', 'steamy'],
  ['her', 'hero', 'shore', 'ashore'],
  ['hit', 'with', 'white', 'weight'],
  ['sat', 'seat', 'tease', 'seated'],
  ['lie', 'evil', 'devil', 'drivel'],
  ['met', 'team', 'steam', 'master'],
  ['ate', 'rate', 'mater', 'stream'],
  ['ace', 'race', 'cater', 'carpet'],
  ['tie', 'tire', 'write', 'winter'],
  ['hat', 'chat', 'teach', 'chalet'],
  ['fee', 'free', 'freed', 'feared'],
  ['eve', 'ever', 'sever', 'server'],
  ['ate', 'tale', 'fetal', 'falter'],
  ['sue', 'sure', 'surge', 'grouse'],
  ['tap', 'tape', 'paste', 'staple'],
  ['pat', 'trap', 'party', 'pastry'],
  ['rat', 'rate', 'rated', 'thread'],
  ['aye', 'year', 'early', 'really'],
  ['tea', 'tear', 'rated', 'thread'],
  ['ate', 'team', 'mater', 'matter'],
  ['use', 'sure', 'curse', 'course'],
  ['rat', 'tear', 'later', 'taller'],  // Replaced 'albert' with 'taller' from sequences2025
  ['met', 'time', 'timer', 'mister'],
  ['ran', 'rang', 'grain', 'caring'],
  ['set', 'nest', 'scent', 'insect'],
  ['ran', 'darn', 'drank', 'ranked'],
  ['aim', 'maid', 'media', 'admire'],
  ['bro', 'born', 'boner', 'broken'],
  ['sin', 'sign', 'sting', 'string'],
  ['set', 'rest', 'store', 'forest'],
  ['far', 'fear', 'frame', 'farmer'],
  ['say', 'stay', 'stray', 'pastry'],
  ['led', 'lied', 'lined', 'denial'],
  ['pin', 'pain', 'panic', 'pacing'],
  ['ran', 'rain', 'grain', 'racing'],
  ['set', 'east', 'taste', 'tasted'],
  ['rip', 'pair', 'april', 'spiral'],
  ['art', 'brat', 'abort', 'barton'],
  ['sat', 'star', 'start', 'artist'],
  ['won', 'worn', 'owner', 'wonder'],
  ['rat', 'part', 'party', 'partly'],
  ['age', 'gear', 'marge', 'mirage'],
  ['man', 'amen', 'meant', 'inmate'],
  ['ain', 'nail', 'alien', 'nailed'],
  ['and', 'sand', 'sedan', 'sundae'],
  ['end', 'bend', 'blend', 'bundle'],
  ['all', 'wall', 'allow', 'wallow'],
  ['fed', 'deaf', 'faced', 'facade'],
  ['net', 'then', 'thine', 'ethnic'],
  ['and', 'sand', 'stand', 'strand'],
  ['not', 'note', 'monte', 'moment'],
  ['out', 'thou', 'touch', 'touchy'],
  ['ten', 'tune', 'untie', 'minute'],
  ['art', 'cart', 'actor', 'factor'],
  ['set', 'site', 'spite', 'septic'],
  ['red', 'dare', 'dream', 'dreamt'],
  ['own', 'worn', 'wrong', 'rowing'],
  ['son', 'nose', 'shone', 'chosen'],
  ['bet', 'debt', 'debut', 'busted'],
  ['ole', 'role', 'loser', 'slower'],
  ['due', 'used', 'fused', 'defuse'],
  ['let', 'late', 'stale', 'salute'],
  ['aim', 'main', 'manic', 'cinema'],
  ['bar', 'bear', 'brake', 'barker'],
  ['lie', 'life', 'filet', 'itself'],
  ['eat', 'tear', 'trade', 'hatred'],
  ['her', 'hero', 'horde', 'holder'],
  ['tea', 'rate', 'cater', 'racket'],
  ['war', 'wear', 'weary', 'lawyer'],
  ['ate', 'rate', 'tread', 'hatred'],
  ['set', 'rest', 'stare', 'master'],
  ['red', 'ride', 'diner', 'dinner'],
  ['sea', 'case', 'scare', 'scared'],
  ['sat', 'east', 'stake', 'streak'],
  ['ram', 'farm', 'frame', 'farmer'],
  ['gun', 'sung', 'using', 'genius'],
  ['far', 'fear', 'safer', 'faster'],
  ['car', 'race', 'crate', 'racket'],
  ['ale', 'meal', 'medal', 'calmed'],
  ['ate', 'meat', 'metal', 'mantle'],
  ['met', 'time', 'merit', 'permit'],
  ['due', 'rude', 'lured', 'hurdle'],
  ['hop', 'hope', 'hoped', 'hopped'],
  ['rob', 'bore', 'borne', 'reborn'],
  ['god', 'dong', 'dingo', 'indigo'],
  ['eat', 'seat', 'steal', 'castle'],
  ['lay', 'ally', 'tally', 'lately'],
  ['air', 'liar', 'trial', 'ritual'],
  ['pot', 'stop', 'sport', 'pastor'],
  ['ate', 'tear', 'cater', 'carpet'],
  ['ran', 'rain', 'drain', 'daring'],
  ['one', 'note', 'atone', 'donate'],
  ['mal', 'lame', 'blame', 'marble'],
  ['rat', 'tear', 'great', 'gather'],
  ['ate', 'rate', 'heart', 'rather'],
  ['for', 'fort', 'frost', 'forest'],
  ['car', 'card', 'raced', 'dancer'],
  ['con', 'once', 'ounce', 'bounce'],
  ['rat', 'tear', 'react', 'create'],
  ['ate', 'seat', 'skate', 'staked'],
  ['old', 'lord', 'older', 'louder'],
  ['car', 'care', 'creak', 'racket'],
  ['age', 'gear', 'argue', 'argued'],
  ['sat', 'seat', 'yeast', 'steady'],
  ['don', 'done', 'devon', 'vendor'],
  ['nor', 'torn', 'tenor', 'rotten'],
  ['wet', 'west', 'sweet', 'newest'],
  ['age', 'gear', 'barge', 'beggar'],
  ['far', 'fair', 'friar', 'fairer'],
  ['don', 'down', 'owned', 'wonder'],
  ['sec', 'case', 'scale', 'castle'],
  ['tie', 'site', 'heist', 'ethics'],
  ['age', 'rage', 'range', 'danger'],
  ['cat', 'chat', 'yacht', 'chatty'],
  ['sea', 'seat', 'sweat', 'sweaty'],
  ['ask', 'task', 'stark', 'skater'],
  ['ill', 'hill', 'chill', 'chilly'],
  ['set', 'best', 'beast', 'stable'],
  ['sat', 'stab', 'beast', 'breast'],
  ['lie', 'lied', 'riled', 'riddle'],
  ['bar', 'bare', 'amber', 'embark'],
  ['elm', 'mile', 'smile', 'simple'],
  ['air', 'pair', 'prima', 'primal'],
  ['tie', 'item', 'timer', 'permit'],
];
